import React, { useEffect, useState } from 'react'
import { callNativeByParams, getUA } from '@penguin/utils'
import { getSlotAd } from '@/api'
import classnames from 'classnames'
import styles from './index.module.css'
import Lottie from 'lottie-react'
import redPacket from '@/assets/lottie/redPacket.json'
const ua = getUA()
const EquityCard = () => {
  const [slotInfo, setSlotInfo] = useState<any>({})
  const getSlot = async () => {
    const res: any = await getSlotAd({ slotKey: 'marketing-h5-haoka-equity-card' })
    setSlotInfo(res)
  }
  useEffect(() => {
    getSlot()
  }, [])

  return (
    <div className={styles['card-pages']}>
      <div className={styles['bg-top']}></div>
      <div className='px-3 text-center relative'>
        <div className={classnames('absolute', styles['top-7'])}>
          <div className='mb-4'>
            <Lottie className={styles['equity-one']} animationData={redPacket} />
          </div>
          {slotInfo && slotInfo.images && (
            <img className='w-full h-40 clear-both mb-5' src={slotInfo.images[0].imageUrl} alt='' />
          )}
          <div className={classnames(styles['bg-btn'], 'mb-5')}>
            <img
              className={styles['icon01']}
              src='https://static.qiekj.com/static/web/image/1_1723183883504.png'
              alt=''
            />
            <img
              className={styles['btn']}
              onClick={() => {
                if (ua === 'app') {
                  callNativeByParams('jumpNativePage', {
                    url: slotInfo.images[0].linkUrl,
                  })
                } else {
                  window.location.href = slotInfo.images[0].linkUrl
                }
              }}
              src='https://static.qiekj.com/static/web/image/bg02_1723182856195.png'
              alt=''
            />
            <img
              className={styles['icon02']}
              src='https://static.qiekj.com/static/web/image/2_1723183900383.png'
              alt=''
            />
          </div>
          <img
            className='mb-5'
            src='https://static.qiekj.com/static/web/image/4_1724057966097.png'
            alt=''
          />
          <img
            className='mb-10'
            src='https://static.qiekj.com/static/web/image/rule01_1723184524490.png'
            alt=''
          />
        </div>
      </div>
    </div>
  )
}

export default EquityCard
